export enum ProductId {
  SG_EI_MC_CLASSIC_ADDON_V1 = "sg.ei.mc-classic-addon.v1",
  SG_MC_CLASSIC_TRIAL_DISCOUNT_V1 = "sg.mc.classic-trial-discount.v1",
}
